import { render } from "./UserPasswordUpdatePage.vue?vue&type=template&id=cb3b6896&scoped=true"
import script from "./UserPasswordUpdatePage.vue?vue&type=script&lang=js"
export * from "./UserPasswordUpdatePage.vue?vue&type=script&lang=js"

import "./UserPasswordUpdatePage.vue?vue&type=style&index=0&id=cb3b6896&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3b6896"]])

export default __exports__